import { useContext, Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { AspectRatio } from './AspectRatio';
import { AuthenticationContext } from '../msal/AuthenticationContext';

import css from './LoginScreen.module.scss';
import sharedCss from '../pages/Shared.module.scss';

class LoginScreenInternal extends Component {
    loginAzureAD = () => {
        this.props.authenticationContext.login(window.location.pathname)
    }

    loginCiam = () => {
        this.props.authenticationContext.loginWithCiam(window.location.pathname)
    }

    render() {

        return <div className={sharedCss.background}>
            <Container fluid={true} className="px-0">
                <div className="bg-secondary d-flex justify-content-between align-items-center p-3">
                    <img className={css.navLogo} src="./images/Robin-logo-500-blue.png" alt="Robin logo"/>
                    <div className="d-flex gap-2">
                        <Button color='primary' onClick={this.loginAzureAD}>Login with Azure AD</Button>
                        <Button color='info' onClick={this.loginCiam}>Login with External ID</Button>
                    </div>
                </div>

                <AspectRatio className={css.topImageContainer} aspectRatio="1:0.21">
                    <img src="./images/houses.png" alt="" />
                    <div className={css.overlayHeader}>
                        <p>Robin Intercom Portal</p>
                    </div>
                </AspectRatio>
            </Container>
            <Container fluid={true} className={`bg-secondary ${css.footerContainer}`}>
                <div className={css.revision}>Revision 1.13</div>
                <Container className={`text-white ${css.footerList}`}>
                    <Row>
                        <Col className="text-center">
                            <ul>
                                <li><h5>Contact information</h5></li>
                                <li>+31 72 534 64 26</li>
                                <li>info@robin.nl</li>
                            </ul>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-center">
                            <p>
                            <span className="ms-1">
                                    © 2020-{(new Date().getFullYear())}{' '}
                                    <a href="https://robin.nl" target="_blank" rel="noopener noreferrer">
                                        Robin
                                    </a>
                                </span>
                                <span>
                                    {' '}
                                    |
                                    <a href="https://robin.nl/disclaimer.html" target="_blank" rel="noopener noreferrer">
                                        <span className="ms-1">Disclaimer</span>
                                    </a>
                                </span>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>;
    }
}

// Wrap the component so that multiple contexts are available via the props.
export const LoginScreen = (props) => {
    const authenticationContext = useContext(AuthenticationContext);
  
    return (
        <LoginScreenInternal authenticationContext={authenticationContext} {...props}/>
    )
}